import { render, staticRenderFns } from "./InsulaSchemeSet.vue?vue&type=template&id=99b2fa48&scoped=true&"
import script from "./InsulaSchemeSet.vue?vue&type=script&lang=js&"
export * from "./InsulaSchemeSet.vue?vue&type=script&lang=js&"
import style0 from "./InsulaSchemeSet.vue?vue&type=style&index=0&id=99b2fa48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.8_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b2fa48",
  null
  
)

export default component.exports